import React, { useEffect, useState } from "react";
import axios from "axios";
import { Chip, Avatar, Box, CircularProgress } from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

const UsersTable = () => {
  const [users, setUsers] = useState([]);
  const [rowsData, setRowsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const admin = localStorage.getItem("admin_id");

  // Fetch Users
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`https://api.homelyx.framekarts.com/api/getAllUser/${admin}`);
      if (res.data.success) {
        setUsers(res.data.data);
      }
    } catch (err) {
      
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [admin]);

  // Columns for DataTable
  const columns = [
    { Header: "S.No", accessor: "no" },
    { Header: "Profile", accessor: "profile" },
    { Header: "Full Name", accessor: "fullName" },
    { Header: "Phone", accessor: "phoneNumber" },
    { Header: "Email", accessor: "email" },
    { Header: "User Type", accessor: "userType" },
    { Header: "Status", accessor: "status" },
    { Header: "Created At", accessor: "createdAt" },
  ];

  // Map users to rows
  useEffect(() => {
    const tempRows = users.map((user, index) => ({
      no: <MDTypography fontSize={12}>{index + 1}</MDTypography>,
      profile: (
        <Avatar src={user.image || ""} sx={{ width: 30, height: 30 }}>
          {!user.image && user.fullName?.[0]}
        </Avatar>
      ),
      fullName: <MDTypography fontSize={12}>{user.fullName}</MDTypography>,
      phoneNumber: <MDTypography fontSize={12}>{user.phoneNumber}</MDTypography>,
      email: <MDTypography fontSize={12}>{user.email}</MDTypography>,
      userType: <MDTypography fontSize={12}>{user.userType.join(", ")}</MDTypography>,
      status: (
        <Chip
          label={user.disable ? "Disabled" : "Active"}
          color={user.disable ? "error" : "success"}
          size="small"
        />
      ),
      createdAt: <MDTypography fontSize={10}>{new Date(user.createdAt).toLocaleDateString()}</MDTypography>,
    }));
    setRowsData(tempRows);
  }, [users]);

  return (
    <Box>
      {loading ? (
        <MDBox display="flex" justifyContent="center" mt={5}>
          <CircularProgress />
        </MDBox>
      ) : (
        <DataTable
          table={{ columns: columns || [], rows: rowsData || [] }}
          isSorted={false}
          entriesPerPage={false}
          canSearch={true}
          pagination={true}
          noEndBorder
        />
      )}
    </Box>
  );
};

export default UsersTable;
